import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
      gap={2}
    >
      <Typography variant="h4" fontWeight={600}>
        403 — Access Denied
      </Typography>
      <Typography variant="body1" color="text.secondary">
        You don&apos;t have permission to view this page.
      </Typography>
      <Button variant="outlined" onClick={() => navigate(-1)} disabled={window.history.length <= 1}>
        Go Back
      </Button>
      <Button variant="contained" onClick={() => navigate('/dashboard')}>
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default AccessDenied;
